import { render, staticRenderFns } from "./TripsByZoneTable.vue?vue&type=template&id=f52de716&"
import script from "./TripsByZoneTable.vue?vue&type=script&lang=js&"
export * from "./TripsByZoneTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports